import React from 'react';
import {
  Button,
  ButtonProps,
  ButtonVariant,
} from '@vimily/bonjoro-ui-components';

export default function ArrowButton({
  className = '',
  disabled = false,
  children,
  onClick,
}: ButtonProps) {
  const arrowButtonClass = [
    'border-neutral-300 text-xl',
    '!p-0 w-[40px] h-[40px]',
    'bg-white disabled:bg-neutral-200',
  ].join(' ');

  return (
    <Button
      className={`${arrowButtonClass} ${className}`}
      variant={ButtonVariant.Info}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </Button>
  );
}
